import React,{useEffect, useState} from 'react';
import {Button} from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import {Modal} from 'react-bootstrap';
//import "./ModalConfirmacion.css";

function ModalPersonalizadoGeneral(datos) {
    const { t } = useTranslation();
    const {comando,dispositivo,ids,cerrarModal} = datos;
    const [confirmado, setConfirmado]= useState(false);
    const [posicion, setPosicion] = useState();
    const [botonAceptar,setBotonAceptar] = useState("disable");

    const handleInputChange2 = (event) => {
        setPosicion(event.target.value);
    }

    const enviarComandoPerso = (event) => {
        event.preventDefault();
        fetch( window.location.protocol+"//"+window.location.hostname+"/api" + '/commands/sendCommandCustom', {
        method: 'POST',
        credentials: 'include',
        headers:{
            'idDevice': dispositivo,
            'idWithinDeviceTable': ids,
            'command': comando,
            'extraValue':posicion
        }
        })
        .then(response => { console.log(response)})
        .catch(e => { console.error(e);})
        
    }

    //Dependiendo de si se pode una posicion se habilita o deshabilita el botón de enviar
    useEffect(()=>{
        if(posicion != null && posicion!=undefined && posicion !=""){
            setBotonAceptar("") 
        }else{
            setBotonAceptar("disabled") 
        }
    },[posicion]);

    return (
        <div className="div">
            <form className="" onSubmit={enviarComandoPerso}>
                <div className="form-content">                    
                    <div className="mt-3">
                        <label>{t('scada.solarFarm.modalCommands.sendGrades')}</label>
                        <input
                            type="number"
                            className="form-control mt-1"
                            placeholder={t('scada.solarFarm.modalCommands.placeholder')}
                            name="grados"
                            onChange={handleInputChange2}
                        />
                    </div>
                    <div className="d-grid gap-2 mt-3">
                        <button type="submit" className="btn btn-primary" disabled={botonAceptar} onClick={() => {setConfirmado(true);}}>{t('scada.solarFarm.modalCommands.acept')}</button>
                    </div>
                    
                </div>
            </form>

            <Modal centered show={confirmado} onHide={() => (setConfirmado(false), cerrarModal(false))} backdrop="static" aria-labelledby="enviado" >
                <Modal.Header closeButton>
                    <Modal.Title>{t('scada.solarFarm.modalCommands.confirmation')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <a>{t('scada.solarFarm.modalCommands.sendMessage')}</a>
                    <br />
                    <Button type="button" className="button_confirm boton-aceptar-enviado" variant="success" size="sm" onClick={() => {setConfirmado(false);cerrarModal(false);}}>{t('scada.solarFarm.modalCommands.acept')}</Button>
                </Modal.Body>
            </Modal>

        </div>
    )
}

export default ModalPersonalizadoGeneral